import textRenderPlugin from './text';
import buttonRenderPlugin from './button';

export {
  textRenderPlugin,
  buttonRenderPlugin
};

export default [textRenderPlugin, buttonRenderPlugin];